<template>
  <div class="input">
    <div class="input-label">トランプ番号</div>
    <div class="input-group">
      <input type="number" min="1" max="13" class="input-text" v-model="cardNumber">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    cardNumber: {
      get: function () {
        return this.$store.state.quiz.cardNumber
      },

      set: function (value) {
        this.$store.commit(
          'quiz/setCardNumber',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
